// Image-to-text via the API's OCR endpoint (POST /image-to-text).
// Accepts a File (new upload) or a same-origin URL (existing gallery image).

import { common } from "./common";

export async function extractText(image: File | string): Promise<string> {
  let blob: Blob;
  let filename = "image.png";
  if (typeof image === "string") {
    const res = await fetch(image, { credentials: "include" });
    if (!res.ok) throw new Error("Could not load the image to extract text from.");
    blob = await res.blob();
    filename = image.split("/").pop() || filename;
  } else {
    blob = image;
    filename = image.name || filename;
  }

  const formData = new FormData();
  formData.append("image", blob, filename);
  const response = await common.fetchRestAPI("image-to-text", "POST", formData);

  if (response.status === 404) {
    throw new Error("Text extraction isn't set up on this server yet.");
  }
  if (response.status === 401) {
    throw new Error("Please log in to extract text from images.");
  }
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error || "Failed to extract text from the image.");
  }

  const body = await response.json().catch(() => null);
  return typeof body?.text === "string" ? body.text : "";
}
